import { extendZodWithOpenApi } from "@anatine/zod-openapi"
import { initContract } from "@ts-rest/core"
import { z } from "zod"

export const c = initContract()

extendZodWithOpenApi( z )
